import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { OrganizationListPathParameters } from 'api/actions/organization-list/organization-list-path-parameters';
import { OrganizationListResponse } from 'api/actions/organization-list/organization-list-response';

type OrganizationListQueryParameters = Record<string, any>;

/**
 * The path of the OrganizationList action.
 */
export const organizationListActionPath = new SweetPath<keyof OrganizationListPathParameters>(
  '/api/organization/list',
  { path: '{param}' }
);

/**
 * Creates a contextualized OrganizationList actions.
 */
export default function createOrganizationListAction(axios: AxiosInstance) {
  return function organizationListAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: OrganizationListQueryParameters } = {}) {
    const path = organizationListActionPath.original;

    return axios.request<OrganizationListResponse, OrganizationListResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
